import '../../sass/auth/index.scss';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';
import cookieStorage from '@common/helpers/cookieStorage';

installGlobalErrorReporter('v5-auth');

if (cookieStorage.get('nightMode') === '1') {
    document.body.classList.add('dark');
}

import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import configureStore from "../core/reducers/configureStore";
import UserReducer from "../core/reducers/UserReducer";
import Index from "./components/Index";
import ModalReducer from "../core/reducers/ModalReducer";
import AuthOptionsReducer from "../core/reducers/AuthOptionsReducer";
import ErrorBoundary from "../core/components/ErrorBoundary";
import SiteReducer from "../core/reducers/SiteReducer";
import {siteSetData} from "../core/actions/SiteActions";
import AuthTabReducer from "../form/reducers/AuthTabReducer";

const store = configureStore({
    site: SiteReducer,
    user: UserReducer,
    modal: ModalReducer,
    authOptions: AuthOptionsReducer,
    authTab: AuthTabReducer,
});

window.rootElement = document.getElementById('auth-app');

const dataset = rootElement.dataset;

store.dispatch(siteSetData({
    facebookAppId: dataset.facebookAppId,
    googleAppId: dataset.googleAppId,
    lang: dataset.lang,
    parentSite: dataset.parentSite,
    parentSiteEmail: dataset.parentSiteEmail,
    signUpEnabled: !!parseInt(dataset.signUpEnabled),
    socialAuthStatus: !!parseInt(dataset.socialAuthStatus),
    socialAuthStatusGoogle: !!parseInt(dataset.socialAuthStatusGoogle),
    recaptchaSiteKey: dataset.recaptchaSiteKey,
}));

render(
    <Provider store={store}>
        <ErrorBoundary>
            <Index />
        </ErrorBoundary>
    </Provider>,
    rootElement,
);
